export const SectionCard = ({ title, children, style }) => {
  return (
    <div
      style={{
        border: 'solid 1px #ddd',
        borderRadius: 8,
        display: 'flex',
        flexDirection: 'column',
        fontSize: '90%',
        width: '100%',
        ...style,
      }}
    >
      {title && (
        <div
          style={{
            fontSize: 16,
            fontWeight: 'bold',
            padding: '12px 16px',
            lineHeight: 1,
            borderBottom: 'solid 1px #eee',
          }}
        >
          {title}
        </div>
      )}
      <div style={{ padding: 16, flex: '1' }}>{children}</div>
    </div>
  );
};
